import React, { Suspense } from 'react';

export const QuestionnairePageComponent = React.lazy(() => import('./QuestionnairePage'));

export const QuestionnairePage = (props) => (
  <Suspense fallback={null}>
    <QuestionnairePageComponent {...props} />
  </Suspense>
);
